<template>
    <div class="">
        <page-header title="Create New Consolidation"
            breadcrumb="Bookings & Shipments > Load Consolidation > Create New"  />
        <div class="px-3 py-4 bg-white mt-5">
            <TabIndicator index="3" />
            <keep-alive>
                <components :is="currentPage"></components>
            </keep-alive>
        </div>
    </div>
</template>

<script>
import AllRoute from "./modules/all-routes.vue"
import AddShipment from "./modules/add-shipments.vue"
import PageHeader from "@/components/UI/NewPageHeader";
import selectFleet from "./modules/select-fleet.vue";
import Confirmation from "./modules/confirmation.vue"
import TabIndicator from "./modules/TabLevel.vue"

export default {
    components: {
        AllRoute,
        AddShipment,
        PageHeader,
        selectFleet,
        TabIndicator
    },
    mounted() {},
    beforeDestroy() {
        this.$store.dispatch('setResetConsolidation')
    },
    computed: {
        getCurrentLevel() {
            return this.$store.getters?.getNewConsolidationLevel
        },
        currentPage() {
            switch (this.getCurrentLevel) {
                case 1:
                    return AllRoute
                case 2:
                    return AddShipment
                case 3:
                    return selectFleet
                case 4:
                    return Confirmation
                default:
                    return AllRoute
            }
        }
    },

}
</script>
